import { render, staticRenderFns } from "./CreateOrUpdateSignatureProfile.vue?vue&type=template&id=482cfddf"
import script from "./CreateOrUpdateSignatureProfile.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateSignatureProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateSignatureProfile.vue?vue&type=style&index=0&id=482cfddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports